<script setup>
import {t} from "@/controllerLK/AvalLocalization";
import SearchSwitcherDefaultIcon from "@/components/Icons/SearchSwitcherDefaultIcon.vue";
import SearchSwitcherSemanticIcon from "@/components/Icons/SearchSwitcherSemanticIcon.vue";
import {useNewsFeedStore} from "@/store/NewsFeed/newsFeed";
import InfoIcon from "@/components/Icons/InfoIcon.vue";

const newsFeedStore = useNewsFeedStore();

const switchSearchType = async (value) => {
  if (value === newsFeedStore.useSemSearch) return;

  newsFeedStore.useSemSearch = value;

  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};
</script>

<template>
  <div 
    class="search-switcher"
    :class="{'search-switcher--with-info': newsFeedStore.useSemSearch}"
  >
    <InfoIcon 
      v-if="newsFeedStore.useSemSearch"
      v-tooltip:bottom="t('news_page_body_roof.info.text_search_switcher')"
      class="search-switcher__info-icon" 
    />
    <button
      v-tooltip:bottom="t('news_page_body_roof.button.classic_search')"
      :class="{'search-switcher__button--active': !newsFeedStore.useSemSearch}"
      class="search-switcher__button"
      @click="switchSearchType(false)"
    >
      <SearchSwitcherDefaultIcon class="search-switcher__button-icon" />
    </button>
    <button
      v-tooltip:bottom="t('news_page_body_roof.button.semantic_search')"
      :class="{'search-switcher__button--active': newsFeedStore.useSemSearch}"
      class="search-switcher__button"
      @click="switchSearchType(true)"
    >
      <SearchSwitcherSemanticIcon class="search-switcher__button-icon" />
    </button>
  </div>
</template>

<style scoped lang="scss">
.search-switcher {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  padding: 4px;
  background: var(--background-01);
  
  &--with-info {
    margin-left: 20px;
  }

  &__button {
    padding: 3px 6px;
    border-radius: 6px;
    color: var(--icon-icon-secondary);
    position: relative;
    background-color: var(--background-01);

    &-icon {
      width: 20px;
      height: 20px;
    }

    &--active {
      color: var(--icon-icon-on-inverse);
      background: var(--background-bg-selected);
    }

    &:not(&--active):hover {
      background: var(--background-bg-hover);
    }
  }

  &__info-icon {
    position: absolute;
    left: -29px;
    width: 26px;
    height: 26px;
    padding: 6px;
    color: var(--icon-icon-secondary);
    margin-right: 8px;
  }
}

</style>